<div class="container-page">
    <mat-card class="container-card">
        <div class="text-not-found">
            404 ページが見つかりません
        </div>
    </mat-card>
</div>
